import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeHtmlMin',
  standalone: true,
})
export class SafeHtmlMinPipe implements PipeTransform {
  constructor() {
  }

  transform(value: string = ''): string {
    if (value) {
      value = value.replace(/<link[^>]*rel="stylesheet"[^>]*>/g, '');
      value = value.replace(/<script[^>]*>.*?<\/script>/g, '');
      value = value.replace(/<script[^>]*>[\s\S]*?<\/script>/g, '');
      value = value.replace(/<form[^>]*>[\s\S]*?<\/form>/g, '');
      value = value.replace(/<style[^>]*>[\s\S]*?<\/style>/g, '');
      value = value.replace(/<input[^>]*>/g, '');
    }
    return value || '';
  }

}
